import { orderBy, unionBy } from 'lodash';

const mergeByProp = (arr, obj, prop) => {
  const i = arr.findIndex(el => el[prop] === obj[prop]);

  return i === -1
    ? [...arr, obj]
    : [...arr.slice(0, i), obj, ...arr.slice(i + 1)];
};

export default function studentLearningTasks(
  state = {
    page: 0,
    count: 0,
    notifications: [],
    unseenCount: undefined,
    unreadCount: undefined,
    unseenMessageCenterCount: 0,
  },
  action,
) {
  switch (action.type) {
    case 'NOTIFICATIONS/MERGE_NOTIFICATIONS':
      return {
        ...state,
        notifications: orderBy(
          unionBy(state.notifications, action.results, 'id'),
          ['id'],
          ['desc'],
        ),
        count: action.count,
        page: state.page + 1,
      };

    case 'NOTIFICATIONS/PRE_MERGE_NOTIFICATIONS':
      return {
        ...state,
        notifications: orderBy(
          unionBy(action.results, state.notifications, 'id'),
          ['id'],
          ['desc'],
        ),
        count: action.count,
      };

    case 'NOTIFICATIONS/MARK_NOTIFICATION_READ':
      return {
        ...state,
        notifications: orderBy(
          mergeByProp([...state.notifications], action.payload, 'id'),
          ['id'],
          ['desc'],
        ),
      };

    case 'NOTIFICATIONS/MARK_ALL_NOTIFICATION_READ':
      return {
        ...state,
        notifications: state.notifications.map(el => ({ ...el, read: true })),
      };

    case 'NOTIFICATIONS/UPDATE_UNSEEN_COUNT':
      return {
        ...state,
        unseenCount: action.count,
        unseenMessageCenterCount: action.messageCount,
        // Reset page when unseen is updated
        page: 0,
      };

    case 'NOTIFICATIONS/UPDATE_UNREAD_COUNT':
      return {
        ...state,
        unreadCount: action.count || 0,
      };

    default:
      return state;
  }
}
